import React from "react";
import { ProductConsumer } from "../../../../Context/AddProWakel";
import Time from "react-time-format";
const G_FirstRow = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            G_zh_wasl,
            G_search_wasl,
            G_date,
            G_del_dis,
            G_getWaslDataBySearchRent,
            G_zh_wasl_katy,
            G_togler,
            G_save,
            inputtogler,
            G_open,
            G_wasl
          } = value;
          const renderdate = (kat) => {
            const monthname = [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12"
            ];
            const date = new Date(kat);

            return `${date.getDate()}/${
              monthname[date.getMonth()]
            }/${date.getFullYear()}`;
          };
          return (
            <>
              <div className="row">
                <div className="col-1 text-right mt2">
                  <button
                    disabled={G_del_dis == true ? true : null}
                    onClick={inputtogler}
                    className="btn btn-info mt4"
                  >
                    <i className="far fa-calendar-alt white "></i>
                  </button>
                </div>

                <div
                  className={`${
                    G_togler == true
                      ? "col-sm-6 text-right"
                      : "col-sm-3 text-right"
                  }`}
                >
                  <div className="form-group">
                    <label className="font-weight-bold f4">بەروار</label>
                    {G_togler == false ? (
                      <input
                        type="text"
                        name="G_date"
                        value={
                          G_search_wasl == true || G_save == true
                            ? renderdate(G_date)
                            : renderdate(Date.now())
                        }
                        className="form-control text-right font-weight-bold"
                      />
                    ) : (
                      <input
                        type="datetime-local"
                        name="G_date"
                        value={G_date}
                        onChange={AddProChange}
                        className="form-control text-right font-weight-bold tc btn btn-info"
                        style={{ margin: "0px 8px" }}
                      />
                    )}
                  </div>
                </div>
                {G_togler == false ? (
                  <div className="col-sm-3 text-right">
                    <div className="form-group">
                      <label className="font-weight-bold f4">کات</label>
                      {G_search_wasl == true || G_save == true ? (
                        <p className="font-weight-bold bg-white p-2 border rounded tc">
                          <Time
                            value={G_wasl.date}
                            format="hh:mm:ss"
                            style={{ color: "black" }}
                          />
                        </p>
                      ) : (
                        <p className="font-weight-bold bg-white p-2 border rounded tc">
                          <Time
                            value={Date.now()}
                            format="hh:mm:ss"
                            style={{ color: "black" }}
                          />
                        </p>
                      )}
                    </div>
                  </div>
                ) : null}

                <div className="col-sm-2 text-right">
                  <div className="form-group">
                    <label className="font-weight-bold f4">ژمارە</label>
                    <input
                      type="number"
                      name="G_zh_wasl"
                      disabled={G_open == true ? true : null}
                      value={G_zh_wasl}
                      onKeyPress={(event) =>
                        event.key == "Enter"
                          ? G_getWaslDataBySearchRent(event)
                          : null
                      }
                      onChange={AddProChange}
                      className={`form-control text-right font-weight-bold ${
                        G_search_wasl == true || G_save == true
                          ? "bg-danger text-white"
                          : ""
                      }`}
                    />
                  </div>
                </div>
                <div className="col-sm-3 text-right">
                  <div className="form-group">
                    <label className="font-weight-bold f4">پسوولە</label>
                    <input
                      type="text"
                      value={G_zh_wasl_katy}
                      className="form-control text-right font-weight-bold font-weight-bold  bg-success text-white"
                    />
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default G_FirstRow;
